export enum ProfileTabTypes {
  NOTIFICATIONS,
  SUBSCRIPTIONS,
  TERMS_AND_CONDITIONS,
}

export enum UserFieldSection {
  NOTIFICATION_CHANNEL = 'notificationChannel',
  LOCALIZATION = 'localization'
}

interface TermsAndConditionsDocumentBase {
  acceptedOn?: Date;
  title: string;
}

export interface TermsAndConditionsDomainConfigDocument extends TermsAndConditionsDocumentBase {
  type: 'domain-config';
  url: string;
}
export interface TermsAndConditionsApiDocument extends TermsAndConditionsDocumentBase {
  type: 'api';
  documentId: string;
  versionId: string;
  language: string;
}

export type TermsAndConditionsDocument = TermsAndConditionsDomainConfigDocument | TermsAndConditionsApiDocument
